"use strict";

// Axios
import axios from "axios";
import qs from "qs";

import { useLoadingStore } from "@/stores/loading";
import { useFlashStore } from "@/stores/FlashStore";
import { useSessionStore } from "@/stores/SessionStore";

axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

const base_url = process.env.VUE_APP_ENDPOINT;
const end_tag = "<!-- {@END_OF_JSON_PAYLOAD@} -->";

export const api = axios.create({
  baseURL: base_url,
  withCredentials: true,
  paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: "repeat" }),
  transformRequest: (data, headers) => {
    headers["Content-Type"] = "application/json";
    return JSON.stringify(data);
  },
});

export const backend = api;

api.interceptors.request.use((config) => {
  const loadingStore = useLoadingStore();
  const sessionStore = useSessionStore();

  config.headers["x-csrf-token"] = sessionStore.csrfToken;

  loadingStore.setLoading(true);
  return config;
});

api.interceptors.response.use(
  (response) => {
    const loadingStore = useLoadingStore();
    loadingStore.setLoading(false);
    return response;
  },
  (error) => {
    const loadingStore = useLoadingStore();
    loadingStore.setLoading(false);

    if (error.response) {
      try {
        const end = error.response.data.indexOf(end_tag);
        const json = error.response.data.substring(0, end);
        const data = JSON.parse(json);
        const message = data.message;
        const type = data.type;

        if (data.type == "SessionNotFound" && window.location.hash.includes("#/login")) {
          // Si es un error de sesion, pero estoy en el login, no hago nada
          return;
        }

        const flashStore = useFlashStore();
        flashStore.setFlash({ message, type });
      } catch (e) {
        console.error(e);
      }
    }

    return Promise.reject(error);
  }
);

export function fetchData(url) {
  return backend.get(url).then((response) => response.data);
}
